import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';

import CircularLoadingIndicator from 'components/indicators/CircularLoadingIndicator';
import SearchResultContainer from './SearchResultContainer';

const RootContainer = styled.div`
  width: 100%;
`;

const ParticipantSearchResultContainer = ({
  participants,
  fetchMore,
  hasNextPage,
  getScrollParentRef,
}) => (
  <RootContainer>
    <InfiniteScroll
      dataLength={participants.length}
      next={fetchMore}
      hasMore={hasNextPage}
      loader={<CircularLoadingIndicator key="loading-indicator" size={32} />}
      scrollableTarget={getScrollParentRef()}
      scrollThreshold={1}
    >
      <SearchResultContainer
        type="participant"
        results={participants}
      />
    </InfiniteScroll>
  </RootContainer>
);

ParticipantSearchResultContainer.propTypes = {
  participants: PropTypes.arrayOf(PropTypes.shape()),
  fetchMore: PropTypes.func,
  hasNextPage: PropTypes.bool,
  getScrollParentRef: PropTypes.func,
};

ParticipantSearchResultContainer.defaultProps = {
  participants: [],
  fetchMore: () => {},
  hasNextPage: false,
  getScrollParentRef: () => {},
};

export default ParticipantSearchResultContainer;
